module.exports = __webpack_public_path__ + "static/media/twig.b9d047a2.svg";